import './Sublabel.scss'

import { SublabelProps } from './types/SublabelTypes'

const Sublabel = ({ text }: SublabelProps) => {
    return (
        <p className="sub-label">{text}</p>
    )
}

export default Sublabel
